export default {
	isLoadedExam: false,
	showAnswer: true,
	bankExam: {},
	roomExam: {},
	roomExamInfo: {},
	roomExamUsersAnswerObj: {},
}
